import { t } from "i18next";
import type { ReleaseEnvironment } from "@packages/commons";
import type { ImportReleaseFormValues } from "./types";

/** Returns `Release {n}`, defaulting to 1 for missing data. */
export const getReleaseUiName = (release: { releaseNo?: number }) =>
  `Release ${release.releaseNo ?? 1}`;

/**
 * Returns the display label for a release environment, translated via i18next.
 */
export const getReleaseEnvLabel = (env?: ReleaseEnvironment): string => {
  if (!env) return t("release_centre.unknown_environment");
  if (env === "test") return t("release_centre.development_environment");
  return t("release_centre.production_environment");
};

/** Builds the `releases/import` request body from the import form. The file must already be selected. */
export const buildImportReleasePayload = (projectId: string, data: ImportReleaseFormValues) => {
  const payload: Record<string, any> = {
    model: projectId,
    payload: data.file.data.compressed,
    active: data.active ?? true,
    preserveConnections: data.preserveConnections ?? true,
    preserveVariables: data.preserveVariables ?? true,
    preserveDerivedTables: data.preserveDerivedTables ?? false,
    preserveMappings: data.preserveMappings ?? false,
  };

  if (data.description?.trim()) {
    payload.description = data.description.trim();
  }

  if (data.releaseNo?.trim()) {
    const num = Number.parseInt(data.releaseNo.trim(), 10);
    if (!Number.isNaN(num) && num > 0) {
      payload.releaseNo = num;
    }
  }

  return payload;
};
